import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: LookupState = {
    filestatuses: [],
    transportmodes: [],
    documenttypes: [],
    activeGoodSupplier: [],
    carriers: [],
    deliverylocations: [],
};

const rootState: LookupState = initialState;

const getters: GetterTree<LookupState, RootState> = {
    filestatuses(state: LookupState): Lookup[] {
        return state.filestatuses;
    },
    transportmodes(state: LookupState): Lookup[] {
        return state.transportmodes;
    },
    documenttypes(state: LookupState): Lookup[] {
        return state.documenttypes;
    },
    activeGoodSupplier(state: LookupState): Lookup[] {
        return state.activeGoodSupplier;
    },
    carriers(state: LookupState): Lookup[] {
        return state.carriers;
    },
    deliverylocations(state: LookupState): Lookup[] {
        return state.deliverylocations;
    },
};

const mutations: MutationTree<LookupState> = {
    SET_FILESTATUSES(state: LookupState, filestatuses: Lookup[]) {
        state.filestatuses = filestatuses;
    },
    SET_TRANSPORTMODES(state: LookupState, transportmodes: Lookup[]) {
        state.transportmodes = transportmodes;
    },
    SET_DOCUMENTTYPES(state: LookupState, documenttypes: Lookup[]) {
        state.documenttypes = documenttypes;
    },
    SET_ACTIVEGOODSUPPLIER(state: LookupState, activeGoodSupplier: Lookup[]) {
        state.activeGoodSupplier = activeGoodSupplier;
    },
    SET_CARRIERS(state: LookupState, carriers: Lookup[]) {
        state.carriers = carriers;
    },
    SET_DELIVERYLOCATIONS(state: LookupState, deliverylocations: Lookup[]) {
        state.deliverylocations = deliverylocations;
    },
    RESET(state: LookupState) {
        Object.assign(state, initialState);
    },
};

const actions: ActionTree<LookupState, RootState> = {
    filestatuses({ commit }, payload: string): any {
        // @ts-ignore
        return this._vm.$api.get('/lookup/filestatuses')
            .then((data: ApiResponseLookup) => {
                commit('SET_FILESTATUSES', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    transportmodes({ commit }, payload: string): any {
        // @ts-ignore
        return this._vm.$api.get('/lookup/transportmodes')
            .then((data: ApiResponseLookup) => {
                commit('SET_TRANSPORTMODES', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    documenttypes({ commit }, payload: string): any {
        // @ts-ignore
        return this._vm.$api.get('/lookup/documenttypes')
            .then((data: ApiResponseLookup) => {
                commit('SET_DOCUMENTTYPES', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    activegoodsuppliers({ commit }, payload: string): any {
        // @ts-ignore
        return this._vm.$api.get('/lookup/activegoodsuppliers')
            .then((data: ApiResponseLookup) => {
                commit('SET_ACTIVEGOODSUPPLIER', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    carriers({ commit }, payload: string): any {
        // @ts-ignore
        return this._vm.$api.get('/lookup/carriers')
            .then((data: ApiResponseLookup) => {
                commit('SET_CARRIERS', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    deliverylocations({ commit }, payload: string): any {
        // @ts-ignore
        return this._vm.$api.get('/lookup/deliverylocations')
            .then((data: ApiResponseLookup) => {
                commit('SET_DELIVERYLOCATIONS', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    randomImage({ commit }, payload: string): any {
        const config = {
            headers: {
                'Content-Length': 0,
                'Content-Type': 'text/plain',
            },
            responseType: 'text',
        };
        // @ts-ignore
        return this._vm.$api.get('/documents/randompicture/uri', config)
            .then((data: ApiResponseLookup) => {
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
